import React, { useContext } from 'react';
import { compact } from 'lodash';
import { routes } from 'constants/config';
import lessonCard from 'images/lesson_card.svg';
import { FilterContext } from 'components/shared/FilterContext/index';
import InsightsTable from '../_shared/InsightsTable';
import DataCardHeader from '../_shared/DataCardHeader';
import DataCardTitle from '../_shared/DataCard/Title';
import Count from '../_shared/Count';
import OverdueAssignmentsRow from './OverdueAssignmentsRow';
import TabSection from '../_shared/TabSection';
import TabSectionTab from '../_shared/TabSectionTab';

const OverdueAssignmentsModule = ({ i18n, vertical }) => {
  const { params: filterParams } = useContext(FilterContext);
  const withFilterQuery = url =>
    compact([url, $.param(filterParams)]).join('?');
  return (
    <section className={`DataCard ${vertical && 'DataCard--vertical'} f-1`}>
      <DataCardHeader
        title={i18n.assignments.overdue.title}
        subtitle={i18n.timeframes.right_now}
        downloadLink={withFilterQuery(routes.INSIGHTS.OVERDUE.REPORT)}
        reportTitle={i18n.assignments.overdue.report.title}
        pendoClassName="trk_link_learning_all-incomplete-assignments-download"
      >
        <Count
          route={routes.INSIGHTS.OVERDUE.ASSIGNMENTS_COUNT}
          imgSrc={lessonCard}
          imgDescription={`${i18n.assignments.overdue.title}:`}
        />
      </DataCardHeader>
      <div className="DataCard-main">
        <DataCardTitle
          title={i18n.assignments.most_overdue_learning_content.title}
          tooltip={i18n.assignments.most_overdue_learning_content.description}
        />
        <InsightsTable
          source={withFilterQuery(routes.INSIGHTS.OVERDUE.CONTENTS)}
          rowComponent={OverdueAssignmentsRow}
          i18n={i18n}
        />
        <TabSection
          title={i18n.assignments.most_overdue_people_and_groups.title}
          tooltip={i18n.assignments.most_overdue_people_and_groups.description}
          className="mt-32"
        >
          <TabSectionTab title={t('people.title')}>
            <InsightsTable
              source={withFilterQuery(routes.INSIGHTS.OVERDUE.USERS)}
              rowComponent={OverdueAssignmentsRow}
              i18n={i18n}
            />
          </TabSectionTab>
          <TabSectionTab title={t('groups.title')}>
            <InsightsTable
              source={withFilterQuery(routes.INSIGHTS.OVERDUE.GROUPS)}
              rowComponent={OverdueAssignmentsRow}
              i18n={i18n}
            />
          </TabSectionTab>
        </TabSection>
      </div>
    </section>
  );
};

export default OverdueAssignmentsModule;
